import { useEffect, useRef, useState } from 'react';
import { FiX as X, FiCompass as Compass } from 'react-icons/fi';
import TravelActivities from './TravelActivities';
import { useLanguageContext } from '../context/languageContext';

export default function ActivitiesPopup() {
  const dialog = useRef(null);
  const [open, setOpen] = useState(false);
  const { language } = useLanguageContext();
  const label = language === 'sq' ? 'Aktivitete' : language?.toLowerCase() === 'it' ? 'Esperienze' : 'Things to do';
  const closeLabel = language === 'sq' ? 'Mbyll' : language?.toLowerCase() === 'it' ? 'Chiudi' : 'Close';

  useEffect(() => {
    if (!open) return;
    const element = dialog.current;
    const previousOverflow = document.body.style.overflow;
    element.showModal();
    document.body.style.overflow = 'hidden';
    return () => {
      element.close();
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  return <>
    <button type="button" onClick={() => setOpen(true)} className="fixed bottom-24 left-4 z-40 flex min-h-[48px] items-center gap-2 rounded-full bg-orange-600 px-4 py-3 text-sm font-bold text-white shadow-lg hover:bg-orange-700">
      <Compass className="h-5 w-5" aria-hidden="true" />{label}
    </button>
    <dialog ref={dialog} aria-labelledby="travel-popup-title" onCancel={() => setOpen(false)} onClose={() => setOpen(false)} className="m-auto max-h-[85dvh] w-[calc(100%_-_24px)] max-w-2xl overflow-y-auto rounded-2xl bg-white p-0 shadow-2xl backdrop:bg-black/60" onClick={event => { if (event.target === event.currentTarget) setOpen(false); }}>
      <div className="sticky top-0 z-10 h-0">
        <div className="absolute right-2 top-2">
        <button type="button" autoFocus aria-label={closeLabel} onClick={() => setOpen(false)} className="flex h-11 w-11 items-center justify-center rounded-full bg-stone-100 text-slate-800 hover:bg-stone-200"><X aria-hidden="true" className="h-5 w-5" /></button>
        </div>
      </div>
      {open && <TravelActivities popup />}
    </dialog>
  </>;
}
